import _DeleteableInput_ from './DeleteableInput';
import _SaveBtn_ from './SaveBtn';
import _AutoSuggestInput_ from './AutoSuggestInput';
import _Input_ from './Input'

export const DeleteableInput = _DeleteableInput_;
export const SaveBtn = _SaveBtn_;
export const AutoSuggestInput = _AutoSuggestInput_;
export const Input = _Input_;



// WEBPACK FOOTER //
// ./src/components/Common/index.js